import {
  ADD_ITEM_TO_CITIES_LIST,
  REMOVE_ITEM_FROM_CITIES_LIST,
  CLEAR_CITIES_LIST,
} from "../types";

export const addCitiesItem = (item) => ({
  type: ADD_ITEM_TO_CITIES_LIST,
  cityData: item,
});

export const removeCitiesItem = (item) => ({
  type: REMOVE_ITEM_FROM_CITIES_LIST,
  cityData: item,
});

export const clearCitiesItems = () => ({
  type: CLEAR_CITIES_LIST,
});

export const addItemToCities = (item) => (dispatch) => {
  dispatch(addCitiesItem(item));
};

export const removeItemFromCities = (item) => (dispatch) => {
  dispatch(removeCitiesItem(item));
};

export const clearCitiesList = () => (dispatch) => {
  dispatch(clearCitiesItems());
};



// WEBPACK FOOTER //
// ./src/actions/citiesList.js